import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import TopNavbar from '../../components/TopNavbar';
import ButtomFooter from '../../components/ButtomFooter';
import Breadcrumbs from '../../components/Breadcrumbs';
import Loading from '../../components/Loading';
import NotPermit from '../../components/NotPermit';
import { useSelector, useDispatch } from 'react-redux';
import AddressLocation from '../../services/locations/address-location';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, Card, Checkbox, message, Modal } from 'antd';
import { Loader, LoaderOptions } from 'google-maps';
import { useSearchParams } from 'react-router-dom';
import {
  API_KEY,
  ONETRUST_PDPA,
  ONETRUST_PRIVACY,
  ONETRUST_PRIVACY_POLICY_URL,
  ONETRUST_TERMS,
  ONETRUST_TERMS_OF_USE_URL,
  ONETRUST_API_URL,
} from '../../config';

import { CloseOutlined } from '@ant-design/icons';

const options: LoaderOptions = {
  /* todo */
};
const loader = new Loader(API_KEY, options);

export type Props = {
  children?: React.ReactNode | (() => React.ReactNode) | any;
  breadcrumbItems?: any;
  breadcrumbMarginBottom?: number;
  containerMaxWidth?: number;
  paddingBottom?: number;
  layoutLoaded?: boolean;
  isManualLoading?: boolean;
  showTechnicianBar?: boolean;
};

const Layout: React.FC<Props> = (props: any) => {
  const {
    children,
    breadcrumbItems = [],
    containerMaxWidth = 1200,
    breadcrumbMarginBottom,
    paddingBottom = 200,
    layoutLoaded = false,
    isManualLoading = false,
    showTechnicianBar = true,
  } = props;

  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const isFetchedUser = useSelector((state: any) => state.isFetchedUser);
  const navigate = useNavigate();

  // const { initialState, setInitialState } = useModel('@@initialState');
  const [searchParams] = useSearchParams();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isPermitted, setIsPermitted] = useState<boolean>(false);

  const [isNetwork, setIsNetwork] = useState<boolean>(false);
  const [isScrollingInModal, setIsScrollingInModal] = useState<any>(false);
  const [isChecker, setIsChecker] = useState<any>(false);
  const [isPrivacy, setIsPrivacy] = useState<boolean>(false);

  const [isNew, setIsNew] = useState<any>(false);

  const [isDateText, setDateText] = useState<any>(false);
  const [dueDate, setdueDate] = useState<any>();
  const [isTermsOfUse, setTermsOfUse] = useState<any>();
  const [isProvactyPolicy, setProvactyPolicy] = useState<any>();
  const [OneTrust, setOneTrust] = useState<any>(`${ONETRUST_API_URL}`);
  const [isCurrentLocationLoading, setIsCurrentLocationLoading] =
    useState<boolean>(false);

  const getCarts = async (userId: any) => {
    let { data } = await axios.get(`/carts/${userId}`);
    if (!data) {
      return;
    }
    const countCartOrderProduct: any = [];
    data.shops.map((x: any) => {
      x.products.map((y: any) => {
        countCartOrderProduct.push(y.product);
      });
    });
    dispatch({
      type: 'UPDATE_ORDER_COUNT',
      data: countCartOrderProduct.length,
    });
  };

  const showPosition = async (position: any) => {
    const google = await loader.load();
    const lat = position.coords.latitude;
    const long = position.coords.longitude;
    const address = await AddressLocation({
      // loader,
      google,
      location: { lat, long },
      isAllResponse: true,
    });
    dispatch({
      type: 'UPDATE_CURRENT_LOCATION',
      data: {
        lat: lat,
        long: long,
      },
    });
    dispatch({
      type: 'UPDATE_CURRENT_ADDRESS',
      data: address,
    });
  };

  const getLocation = () => {
    setIsCurrentLocationLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      const msg = 'Geolocation is not supported by this browser.';
      message.warning(msg);
    }
  };

  const getLoaderGoogle = async () => {
    const google = await loader.load();
    dispatch({
      type: 'UPDATE_LOADER_GOOGLE',
      data: google,
    });
  };

  const getSettings = async () => {
    const {
      data: { data },
    } = await axios.get(`/settings`);
    const settings = data ? data : {};

    dispatch({
      type: 'UPDATE_SETTINGS',
      data: settings,
    });
  };
  const handleCancel = async () => {
    setIsNetwork(false);

    axios.get(`/pdpa-user/${user?._id}`).then(async (data) => {
      if (data.data) {
        const datetoset = new Date();
        let dataNew = data?.data?.pdpaDetail?.news?.acceptDate;
        if (isPrivacy !== data.data.pdpa.news) {
          dataNew = datetoset;
          axios.post(OneTrust, {
            identifier: user?.phone,
            // **** UAT START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImNiY2ZlMDQ3LTgxOGEtNGQ3NC1iNTcxLWJiNDhkYTkwMGEwMSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEyOjAyLjE1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX05ld3MgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZjI2MTVkZjYtYWFjNi00YjdiLTk0ZWItZjA5MzNhMDY2YTZkIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.I6O1yi43O6k9Edx_yn2aROtVK4ecXftyn0b_HyEoqSG7svzgxBh0xIL-BptAAy5VHFKVf-P0KfcoV0iVwD2RQdg0EX9DFx4J_A87wpT_frAFFYuXoEAGW6cv3ThOeR8MV7uzgjdo0bJi1QDl2D0kf1tdTDL_0KfHXmu_lPtOZq6vAqp9ewhvssiNMrWgJHhORGEE8k1BujGT8I9oqhssuWRnw2PoHGnUwtnbtPz6LoXsa1Ew4q2PUsnhB_fnn3CSrUz0iZZCjooAxxtkrZij5fXyFjZfUfnegDCMnVLtCNtWpuaYAp5hExn-TLKnxWHnqfiPikyo0NzuKx4Prj0fDBlL4-wSBH8jijJrQXGnnP7udnrvepvniPzRpQ3TzyfVy0v4QRnjpPK2MyEDykok5Zgf87KXwclDUhw9nbgpjD5cwfzLqabT5J7y04IgAbJdD2Qa4Ip56tm0_D6urOlXOGOYq7tFKPcLXFcR18DHOh8w10mJFbUtx8Zacnb8i4UBwQEcFMDLSTl-KSTf1gV6sCztrbUQL4zI5zyJnE4DW2rl2F3dGG-DIQ915XDclLEA8HY1l73XhHG3JT2_dN6IYhQfEtlaa8-OaKYAsv9v9E_yR2b8gRWBk3RY381MdN216clW-DeuHwcgVaDTBpadWDEDC3ab9qduBdJ5MQ9po0o",
            // purposes: [
            //   {
            //     Id: "f2615df6-aac6-4b7b-94eb-f0933a066a6d",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** UAT END ****
            // **** PRODUCTION START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImEzOWYzOGZmLWI5OGMtNDhjNS04NDg0LTg3YjE1Yzg0MmY3OCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjUxLjc1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX0Nvb2tpZXMgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjM0ODIwZDczLWU5MmItNDk3Yi1hMmFlLTYxNDliMTRmZTNkZCIsInZlcnNpb24iOjIsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.KYSNg6-2j-PiAyIo1pAhSflG6z6dmxmT97bqTQgABvXoAQL-h1lR90eF6J9LMZtSywqm6TPNW566o5EQurkiQ5GtPMwq-x267t8U4DX7O9Z4niB9kazlZ-3muOgJyW-NSfL8cncm2wJtwAIy5R1jRvEpbRyE8N4fclmOJyl_7wlopBZe5HVd7qEYtDdZkxG7bhGt6XjVe6WFWdNsMF5D3zD8KJGuZEkHk7oqBV6s1BNCBDofitRzcnLs50g7jYc_31Dlh1JebNHPnFJpzFAABeSn3KKYbYYctZMHDhPjBdw0E8tZ1gSy_b8Nov8ZUPKatv5XimEWPaXgzC5ngVw5UlWaFXNs5P0_-XnYacBPJMEMrA7dN7WAv5koch9EQyJYrAkcnIb23jSV7CmXakfJoZKRns3LqxPmC6vP1aAQdHoRd5T_-xUxBb0SkPpzaEmKdZ7JKvTip7cw0vH0677IuaZhDGuGIZPgh4IB5xjQ0OgSS4NsdQ3rc3n72iDJ90D1hf7BRxU-XHIkElwisJGrBND6BGFflxmBTizIUOsAKqP-FTeX0_fNgytMoIvHy5T1rSOb9qJJYwJIt1P8WHAxxd_l5o3TWAHf382-3WYVkgid6x5aq8sJ2YQ8RZoNnQdDAl_72rrXgXvudGGMwZGg6Cg88h2Ki5WeOYvA2wfpbcw",
            // purposes: [
            //   {
            //     Id: "34820d73-e92b-497b-a2ae-6149b14fe3dd",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** PRODUCTION END ****
            requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_PRIVACY.ID}`,
                TransactionType: 'CONFIRMED',
              },
            ],
          });
        }

        let privacyPolicy = data.data.pdpa.privacyPolicy;
        let dateprivacyPolicy = data.data.pdpaDetail.privacyPolicy.acceptDate;
        if (!data.data.pdpa.privacyPolicy) {
          privacyPolicy = true;
          dateprivacyPolicy = datetoset;
          //privacy
          axios.post(OneTrust, {
            identifier: user?.phone,
            // **** UAT START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjA1NTAwZTM4LTI0MWEtNGRiOS1iOTJjLTE3OWM2NDliNDBhYSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjE0OjIxLjIzMyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1ByaXZhY3lQb2xpY3kgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiOGRmN2ZkODQtYTJiNi00YTI5LWI5NTMtYzczOTdiMjA1NzExIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.DJIszFr-LoIa9hzdE16RGDNrcBA5Gdj9D7o1lkLdJlHsaNuvtRBQMZH_Y7dLInEz0dtSOwX-C-HswEChUPxBsGTLW7f51f3nh7iX6NDq402wwF3khLZs5iy9i8YIO3sOj61QBhcIaUznx1_219JxlmaLyTLPMLrUvIuAYLz5QRx1f4V4eT0zvC_KhSYOqQeyXRrVAUlHUwYslx4XDZIvpZL5OOm3rKrxV41RiouNDLvySdcvu-K9dIzrlMsMtt8RTF8kxfUVeDCt6Dl4Ij0qC5i_ua9BWe_FlwVu8XAao5nzp5dh2CPwWtUQfKL_OiiXjqie6t7mJp24zUu-BEUCHFA4l1vZ8a_Far71Kq1xbpmysVB9Yx3sq3BxijC5WPW6_sMjZMP6Lbfob5CPXE--A1RIX2zp6uKKgSPk6nnbaqKXb0Iai-OGVYw7RQdplLhJ1arI6t0w7-znqZZsk4KLR1-QbCjXifXLZkIMrNBXoBgMhUIDWBaWWWbOT4W2lrtHYi1nlIhR45sWvGhgg1517ESQyRGbruTRFj4HrK6HhscqMQsbbuDYznvjPeRKd3m0z1mD7gmu-_uBWLhSMjyamewR-FYv_6YG5JKHMFxDL6xSt4AE0w1mgketkmCO3ViNxiNyZoJuF1DMkQGMV0a9somenkhWlETQjoFBO0hpISw",
            // purposes: [
            //   {
            //     Id: "8df7fd84-a2b6-4a29-b953-c7397b205711",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** UAT END ****
            // **** PRODUCTION START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjY1ZmUwNzNkLTQ3MGEtNDI2ZC1hNTMwLTg5MDJlZjc5ODQwYiIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMyOjEzLjc1MyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1ByaXZhY3lQb2xpY3kgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6ImE1ZGY5MmZhLTg2M2ItNGQzYS1iNjg0LTRhNTE5MzRkM2FmOCIsInZlcnNpb24iOjMsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.gSVooCm7I9sduUeJFOS6lk3RdSLLdBzatBQtRy_KpTkcC-Bqr1hjrju8iQo5wkuVxNZrX0s5pGw9ZNqgxkaA2CrbXGS5-ArJmSK40WoR0EooMw5XGAHgbmqhR1rn3o8ICuqjAOXjG4cqH0Z6KiP1qH3izzQ6Bdwigw5--_G3lHHpbG9negntqD95oPVrhVbsOr_ycsZTgaldtbwaGSM6E9gGZL5-t2GTOYH4F1oqpHm_BYs7OaJ3E7kFcc7bIu42Ig8o46KdorBFjUDxe_44mbReCkQqSTJCll4oQvP75m0eJL7XddLQXFk5qLqo5eY5-PYI9XVNhFBZ8lBRgc6RanmL1WEw6ejTzIM-xBwYTFBi3qweNZp12aJoUwU46vUbRTsz8EoXheIEK9teN2sxQOcAAzNC0KzVWc1-8BHXZq4nSIRrVJGKBgHDl1AXPe7nscbk78gq95T-f4kjjE_v1lOJGDa9gzjSyYStxXRRWD52G5ZiyqQ-3JIxwqAheYMU0xWowPQsTGk99SoQrNpiBrxdUL7mGVgG2HU7yzCaXPbDaIujB8K1PBrgGcMQgBYTC3zTmReZkQ-zteNa2FLfyxiWkmWzwzrhqF7CCK5crlXuIU5cRQzxSHbCyzwjfWLOjlsDKLKFZzhHdRUJzOvEwcbu2z5IY5BPK_2q80npbCI",
            // purposes: [
            //   {
            //     Id: "a5df92fa-863b-4d3a-b684-4a51934d3af8",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** PRODUCTION END ****
            requestInformation: `${ONETRUST_PDPA.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_PDPA.ID}`,
                TransactionType: 'CONFIRMED',
              },
            ],
          });
        }
        let termsConditions = data.data.pdpa.termsConditions;
        let datetermsConditions =
          data.data.pdpaDetail.termsConditions.acceptDate;
        if (!data.data.pdpa.termsConditions) {
          termsConditions = true;
          datetermsConditions = datetoset;
          //terms
          axios.post(OneTrust, {
            identifier: user?.phone,
            // **** UAT START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjkxY2EzYTQ3LWI0MjMtNGFhYy1iNTBlLWIzNGQ2MjNjNDI3MyIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjE0OjUxLjMyIiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNjY5MjQ3ZjAtYjAyOC00ZjdlLWE4MTktNWU3ODA1NDZiYTA2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfVGVybXNDb25kaXRpb25zIEJ1eWVyIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjcyZDYxOTExLTdlMDktNDE4Zi1hZjI5LTEyMWQ5OTdlYmMzMSIsInZlcnNpb24iOjEsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.apEuxBWzD-8y5T5cINt07v_O0FnBVBOzMfhFg3ss5Xy6sUbOww-W6hJqhZdysggCZd06P2ENHQpV0A47BfRMbTElyit8H73jtpJSD0W1HOE6p9QZiXdF2u25TEQcNsNHPoG4Ykv4m5zH_zVcstKCKDG4lRPqeVq8qofxpi_ovuFVxFi6FC5NAj1nuQuX6z3OoNrOfox6HQ74iieFXUfRGlR4gXP-prmXNpc35TNiQCmZNpHydKuFyXC4MDKPn4gAFgM5zWe7BvhOmhHbLod_T3mqLnXlMHV6a0sY2by0N2QAeAt8E_xAP4Ywl_FLsHxB1HP0nr7JUJja9U9jx9nXHcgDaaeXNEVuo2cI9Z4eSb2bT1AWPZNVt6R4tTuTvtc3CgJ7EGGh5twYWz0PaVycjCllgTxomiVgATA8JHJq29BgW6FWMz8k5wPkAbrCw3OKMvsKBHOiMEPpFnXvaV9UqK6s1FwOh9dC0TYFv_TzFrpRDgYixgT77EotrFj9cfvcnOVgT1tJPNxzLxVRBJblVybX1fgNe1obCNevQxAl-6sOIDv0LD5UHIczlbuIzKVd1y4zpK5KKEqf2A8MpcEtP32tEKb9SVed-iWaE0FHT08qxll5szVdP0cDzxUNooLbjxwh1npV-QaEKpzVzqdAwiJw9a07z8ShulYMwkGKxPY",
            // purposes: [
            //   {
            //     Id: "72d61911-7e09-418f-af29-121d997ebc31",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** UAT END ****
            // **** PRODUCTION START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjEwMzllMDQ2LWQ5YmUtNDFiMi1iZWYyLTY5ODAxMDYxZmJlNCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMyOjM2LjE4MyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1Rlcm1zQ29uZGl0aW9ucyBCdXllciBVQVQiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZDVmYWQ0YjItYjIwMS00ZWE3LTg1NjktZmRlNGQwMGE0NjRhIiwidmVyc2lvbiI6MiwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.B4i8n_iK-l6sFj_hlYZrv-tk8mvOdvuiRwj5hCLN-LCRPYzhy19J3AgucaNnV4WWBRN7SwcbessSjSXRNixFkSgV9bUWHhx07nECdfQQ-qocYDV8nb9mXkW7PBLZbU4jIixkgQmBpr6Y6okgWOuAKsnp1i3PA1Ast-WFOwzFsjRVr-JNGu6egwvzeOJiIqfMkub1Oycg6XOOHj4eTm4UlyoDQbz-MeA5JvbCUpN-Zm-QH6smAQS4a-cQ7mZr8xNuR2vCLR0v2A1PQstaT_CbXArY8n0xHczClTgjttWi8E3SnjiXvIkF8ST9uoXMDGyb347oG6Id2weX5C0KE4ThcJ-qWrN2usnfR3Ga5XR8pnElkwnYru1vO9rZrHCwgKgCG_zaPRd2LPpA7h1-DWUkStYPHQ_pRah7N907BboVdh8pzrN_qW5ux56BoJxWBC5F4SgFtra_Rw3eV_WtDrHiiS0_IS2AMU6Cath6WAIEmSX3FrIAEEz9DYadgjDzfDhxnzpK5SR7SpFN4pYXo2eZneVUfTtgV4pNUWJKXl3Am9MSEnwfNywXM_xYjw0MLZFFov7S4cjdKCHBlGGvYr7h6gx7RORw6kRBtgjvhqNrh8dgB0idInbEfgvjU1_LmCaohuHvH-UTdtyO5hc-6OWdCB4XOFsx3TOiNZdLem6b35M",
            // purposes: [
            //   {
            //     Id: "d5fad4b2-b201-4ea7-8569-fde4d00a464a",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** PRODUCTION END ****
            requestInformation: `${ONETRUST_TERMS.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_TERMS.ID}`,
                TransactionType: 'CONFIRMED',
              },
            ],
          });
        }

        const pdpa = {
          privacyPolicy: privacyPolicy,
          termsConditions: termsConditions,
          news: isPrivacy,
          personalInformation: data.data.pdpa.personalInformation,
        };
        const pdpaDetail = {
          privacyPolicy: {
            version: isProvactyPolicy.version,
            acceptDate: dateprivacyPolicy,
          },
          termsConditions: {
            version: isTermsOfUse.version,
            acceptDate: datetermsConditions,
          },
          news: {
            version: 1,
            acceptDate: dataNew,
          },
          personalInformation: {
            version: 1,
            acceptDate: data.data.pdpaDetail.termsConditions.acceptDate,
          },
        };

        if (data.data) {
          const checkBoxsUser = await axios.patch(`/pdpa-user/${user?._id}`, {
            pdpa: {
              privacyPolicy: pdpa.privacyPolicy,
              termsConditions: pdpa.termsConditions,
              news: pdpa.news,
              personalInformation: pdpa.personalInformation,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: pdpaDetail.privacyPolicy.version,
                acceptDate: pdpaDetail.privacyPolicy.acceptDate,
              },
              termsConditions: {
                version: pdpaDetail.termsConditions.version,
                acceptDate: pdpaDetail.termsConditions.acceptDate,
              },
              news: {
                version: pdpaDetail.news.version,
                acceptDate: pdpaDetail.news.acceptDate,
              },
              personalInformation: {
                version: pdpaDetail.personalInformation.version,
                acceptDate: pdpaDetail.personalInformation.acceptDate,
              },
            },
          });
        } else {
          const checkBoxsUser = await axios.post(`/pdpa-user`, {
            userId: user?._id,
            version: '1',
            pdpa: {
              privacyPolicy: pdpa.privacyPolicy,
              termsConditions: pdpa.termsConditions,
              news: pdpa.news,
              personalInformation: pdpa.personalInformation,
            },
            pdpaDetail: {
              privacyPolicy: {
                version: pdpaDetail.privacyPolicy.version,
                acceptDate: pdpaDetail.privacyPolicy.acceptDate,
              },
              termsConditions: {
                version: pdpaDetail.termsConditions.version,
                acceptDate: pdpaDetail.termsConditions.acceptDate,
              },
              news: {
                version: pdpaDetail.news.version,
                acceptDate: pdpaDetail.news.acceptDate,
              },
              personalInformation: {
                version: pdpaDetail.personalInformation.version,
                acceptDate: pdpaDetail.personalInformation.acceptDate,
              },
            },
          });
        }
        const checkBoxsLog = await axios.post(`/pdpa-log`, {
          userId: user?._id,
          version: '1',
          pdpa: {
            privacyPolicy: pdpa.privacyPolicy,
            termsConditions: pdpa.termsConditions,
            news: pdpa.news,
            personalInformation: pdpa.personalInformation,
          },
          pdpaDetail: {
            privacyPolicy: {
              version: pdpaDetail.privacyPolicy.version,
              acceptDate: pdpaDetail.privacyPolicy.acceptDate,
            },
            termsConditions: {
              version: pdpaDetail.termsConditions.version,
              acceptDate: pdpaDetail.termsConditions.acceptDate,
            },
            news: {
              version: pdpaDetail.news.version,
              acceptDate: pdpaDetail.news.acceptDate,
            },
            personalInformation: {
              version: pdpaDetail.personalInformation.version,
              acceptDate: pdpaDetail.personalInformation.acceptDate,
            },
          },
        });

        setIsNetwork(false);
      } else {
        const datetoset = new Date();
        //terms
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjkxY2EzYTQ3LWI0MjMtNGFhYy1iNTBlLWIzNGQ2MjNjNDI3MyIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjE0OjUxLjMyIiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNjY5MjQ3ZjAtYjAyOC00ZjdlLWE4MTktNWU3ODA1NDZiYTA2IiwiZGVzY3JpcHRpb24iOiJQcm9tcHREZWVfVGVybXNDb25kaXRpb25zIEJ1eWVyIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjcyZDYxOTExLTdlMDktNDE4Zi1hZjI5LTEyMWQ5OTdlYmMzMSIsInZlcnNpb24iOjEsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.apEuxBWzD-8y5T5cINt07v_O0FnBVBOzMfhFg3ss5Xy6sUbOww-W6hJqhZdysggCZd06P2ENHQpV0A47BfRMbTElyit8H73jtpJSD0W1HOE6p9QZiXdF2u25TEQcNsNHPoG4Ykv4m5zH_zVcstKCKDG4lRPqeVq8qofxpi_ovuFVxFi6FC5NAj1nuQuX6z3OoNrOfox6HQ74iieFXUfRGlR4gXP-prmXNpc35TNiQCmZNpHydKuFyXC4MDKPn4gAFgM5zWe7BvhOmhHbLod_T3mqLnXlMHV6a0sY2by0N2QAeAt8E_xAP4Ywl_FLsHxB1HP0nr7JUJja9U9jx9nXHcgDaaeXNEVuo2cI9Z4eSb2bT1AWPZNVt6R4tTuTvtc3CgJ7EGGh5twYWz0PaVycjCllgTxomiVgATA8JHJq29BgW6FWMz8k5wPkAbrCw3OKMvsKBHOiMEPpFnXvaV9UqK6s1FwOh9dC0TYFv_TzFrpRDgYixgT77EotrFj9cfvcnOVgT1tJPNxzLxVRBJblVybX1fgNe1obCNevQxAl-6sOIDv0LD5UHIczlbuIzKVd1y4zpK5KKEqf2A8MpcEtP32tEKb9SVed-iWaE0FHT08qxll5szVdP0cDzxUNooLbjxwh1npV-QaEKpzVzqdAwiJw9a07z8ShulYMwkGKxPY",
          // purposes: [
          //   {
          //     Id: "72d61911-7e09-418f-af29-121d997ebc31",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjEwMzllMDQ2LWQ5YmUtNDFiMi1iZWYyLTY5ODAxMDYxZmJlNCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMyOjM2LjE4MyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1Rlcm1zQ29uZGl0aW9ucyBCdXllciBVQVQiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZDVmYWQ0YjItYjIwMS00ZWE3LTg1NjktZmRlNGQwMGE0NjRhIiwidmVyc2lvbiI6MiwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.B4i8n_iK-l6sFj_hlYZrv-tk8mvOdvuiRwj5hCLN-LCRPYzhy19J3AgucaNnV4WWBRN7SwcbessSjSXRNixFkSgV9bUWHhx07nECdfQQ-qocYDV8nb9mXkW7PBLZbU4jIixkgQmBpr6Y6okgWOuAKsnp1i3PA1Ast-WFOwzFsjRVr-JNGu6egwvzeOJiIqfMkub1Oycg6XOOHj4eTm4UlyoDQbz-MeA5JvbCUpN-Zm-QH6smAQS4a-cQ7mZr8xNuR2vCLR0v2A1PQstaT_CbXArY8n0xHczClTgjttWi8E3SnjiXvIkF8ST9uoXMDGyb347oG6Id2weX5C0KE4ThcJ-qWrN2usnfR3Ga5XR8pnElkwnYru1vO9rZrHCwgKgCG_zaPRd2LPpA7h1-DWUkStYPHQ_pRah7N907BboVdh8pzrN_qW5ux56BoJxWBC5F4SgFtra_Rw3eV_WtDrHiiS0_IS2AMU6Cath6WAIEmSX3FrIAEEz9DYadgjDzfDhxnzpK5SR7SpFN4pYXo2eZneVUfTtgV4pNUWJKXl3Am9MSEnwfNywXM_xYjw0MLZFFov7S4cjdKCHBlGGvYr7h6gx7RORw6kRBtgjvhqNrh8dgB0idInbEfgvjU1_LmCaohuHvH-UTdtyO5hc-6OWdCB4XOFsx3TOiNZdLem6b35M",
          // purposes: [
          //   {
          //     Id: "d5fad4b2-b201-4ea7-8569-fde4d00a464a",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_TERMS.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_TERMS.ID}`,
              TransactionType: 'CONFIRMED',
            },
          ],
        });
        //privacy
        axios.post(OneTrust, {
          identifier: user?.phone,
          // **** UAT START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjA1NTAwZTM4LTI0MWEtNGRiOS1iOTJjLTE3OWM2NDliNDBhYSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjE0OjIxLjIzMyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1ByaXZhY3lQb2xpY3kgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiOGRmN2ZkODQtYTJiNi00YTI5LWI5NTMtYzczOTdiMjA1NzExIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.DJIszFr-LoIa9hzdE16RGDNrcBA5Gdj9D7o1lkLdJlHsaNuvtRBQMZH_Y7dLInEz0dtSOwX-C-HswEChUPxBsGTLW7f51f3nh7iX6NDq402wwF3khLZs5iy9i8YIO3sOj61QBhcIaUznx1_219JxlmaLyTLPMLrUvIuAYLz5QRx1f4V4eT0zvC_KhSYOqQeyXRrVAUlHUwYslx4XDZIvpZL5OOm3rKrxV41RiouNDLvySdcvu-K9dIzrlMsMtt8RTF8kxfUVeDCt6Dl4Ij0qC5i_ua9BWe_FlwVu8XAao5nzp5dh2CPwWtUQfKL_OiiXjqie6t7mJp24zUu-BEUCHFA4l1vZ8a_Far71Kq1xbpmysVB9Yx3sq3BxijC5WPW6_sMjZMP6Lbfob5CPXE--A1RIX2zp6uKKgSPk6nnbaqKXb0Iai-OGVYw7RQdplLhJ1arI6t0w7-znqZZsk4KLR1-QbCjXifXLZkIMrNBXoBgMhUIDWBaWWWbOT4W2lrtHYi1nlIhR45sWvGhgg1517ESQyRGbruTRFj4HrK6HhscqMQsbbuDYznvjPeRKd3m0z1mD7gmu-_uBWLhSMjyamewR-FYv_6YG5JKHMFxDL6xSt4AE0w1mgketkmCO3ViNxiNyZoJuF1DMkQGMV0a9somenkhWlETQjoFBO0hpISw",
          // purposes: [
          //   {
          //     Id: "8df7fd84-a2b6-4a29-b953-c7397b205711",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** UAT END ****
          // **** PRODUCTION START ****
          // requestInformation:
          //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6IjY1ZmUwNzNkLTQ3MGEtNDI2ZC1hNTMwLTg5MDJlZjc5ODQwYiIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMyOjEzLjc1MyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX1ByaXZhY3lQb2xpY3kgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6ImE1ZGY5MmZhLTg2M2ItNGQzYS1iNjg0LTRhNTE5MzRkM2FmOCIsInZlcnNpb24iOjMsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.gSVooCm7I9sduUeJFOS6lk3RdSLLdBzatBQtRy_KpTkcC-Bqr1hjrju8iQo5wkuVxNZrX0s5pGw9ZNqgxkaA2CrbXGS5-ArJmSK40WoR0EooMw5XGAHgbmqhR1rn3o8ICuqjAOXjG4cqH0Z6KiP1qH3izzQ6Bdwigw5--_G3lHHpbG9negntqD95oPVrhVbsOr_ycsZTgaldtbwaGSM6E9gGZL5-t2GTOYH4F1oqpHm_BYs7OaJ3E7kFcc7bIu42Ig8o46KdorBFjUDxe_44mbReCkQqSTJCll4oQvP75m0eJL7XddLQXFk5qLqo5eY5-PYI9XVNhFBZ8lBRgc6RanmL1WEw6ejTzIM-xBwYTFBi3qweNZp12aJoUwU46vUbRTsz8EoXheIEK9teN2sxQOcAAzNC0KzVWc1-8BHXZq4nSIRrVJGKBgHDl1AXPe7nscbk78gq95T-f4kjjE_v1lOJGDa9gzjSyYStxXRRWD52G5ZiyqQ-3JIxwqAheYMU0xWowPQsTGk99SoQrNpiBrxdUL7mGVgG2HU7yzCaXPbDaIujB8K1PBrgGcMQgBYTC3zTmReZkQ-zteNa2FLfyxiWkmWzwzrhqF7CCK5crlXuIU5cRQzxSHbCyzwjfWLOjlsDKLKFZzhHdRUJzOvEwcbu2z5IY5BPK_2q80npbCI",
          // purposes: [
          //   {
          //     Id: "a5df92fa-863b-4d3a-b684-4a51934d3af8",
          //     TransactionType: "CONFIRMED",
          //     //   "TransactionType": "WITHDRAWN"
          //   },
          // ],
          // **** PRODUCTION END ****
          requestInformation: `${ONETRUST_PDPA.TOKEN}`,
          purposes: [
            {
              Id: `${ONETRUST_PDPA.ID}`,
              TransactionType: 'CONFIRMED',
            },
          ],
        });
        if (isPrivacy) {
          axios.post(OneTrust, {
            identifier: user?.phone,
            // **** UAT START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImNiY2ZlMDQ3LTgxOGEtNGQ3NC1iNTcxLWJiNDhkYTkwMGEwMSIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTMxVDA5OjEyOjAyLjE1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjY2OTI0N2YwLWIwMjgtNGY3ZS1hODE5LTVlNzgwNTQ2YmEwNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX05ld3MgQnV5ZXIiLCJjb25zZW50VHlwZSI6IkNPTkRJVElPTkFMVFJJR0dFUiIsImFsbG93Tm90R2l2ZW5Db25zZW50cyI6ZmFsc2UsImRvdWJsZU9wdEluIjpmYWxzZSwicHVycG9zZXMiOlt7ImlkIjoiZjI2MTVkZjYtYWFjNi00YjdiLTk0ZWItZjA5MzNhMDY2YTZkIiwidmVyc2lvbiI6MSwicGFyZW50SWQiOm51bGwsInRvcGljcyI6W10sImN1c3RvbVByZWZlcmVuY2VzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfV0sIm5vdGljZXMiOltdLCJkc0RhdGFFbGVtZW50cyI6W10sImF1dGhlbnRpY2F0aW9uUmVxdWlyZWQiOmZhbHNlLCJyZWNvbmZpcm1BY3RpdmVQdXJwb3NlIjpmYWxzZSwib3ZlcnJpZGVBY3RpdmVQdXJwb3NlIjp0cnVlLCJkeW5hbWljQ29sbGVjdGlvblBvaW50IjpmYWxzZSwiYWRkaXRpb25hbElkZW50aWZpZXJzIjpbXSwibXVsdGlwbGVJZGVudGlmaWVyVHlwZXMiOmZhbHNlLCJlbmFibGVQYXJlbnRQcmltYXJ5SWRlbnRpZmllcnMiOmZhbHNlLCJwYXJlbnRQcmltYXJ5SWRlbnRpZmllcnNUeXBlIjpudWxsLCJhZGRpdGlvbmFsUGFyZW50SWRlbnRpZmllclR5cGVzIjpbXSwiZW5hYmxlR2VvbG9jYXRpb24iOmZhbHNlfQ.I6O1yi43O6k9Edx_yn2aROtVK4ecXftyn0b_HyEoqSG7svzgxBh0xIL-BptAAy5VHFKVf-P0KfcoV0iVwD2RQdg0EX9DFx4J_A87wpT_frAFFYuXoEAGW6cv3ThOeR8MV7uzgjdo0bJi1QDl2D0kf1tdTDL_0KfHXmu_lPtOZq6vAqp9ewhvssiNMrWgJHhORGEE8k1BujGT8I9oqhssuWRnw2PoHGnUwtnbtPz6LoXsa1Ew4q2PUsnhB_fnn3CSrUz0iZZCjooAxxtkrZij5fXyFjZfUfnegDCMnVLtCNtWpuaYAp5hExn-TLKnxWHnqfiPikyo0NzuKx4Prj0fDBlL4-wSBH8jijJrQXGnnP7udnrvepvniPzRpQ3TzyfVy0v4QRnjpPK2MyEDykok5Zgf87KXwclDUhw9nbgpjD5cwfzLqabT5J7y04IgAbJdD2Qa4Ip56tm0_D6urOlXOGOYq7tFKPcLXFcR18DHOh8w10mJFbUtx8Zacnb8i4UBwQEcFMDLSTl-KSTf1gV6sCztrbUQL4zI5zyJnE4DW2rl2F3dGG-DIQ915XDclLEA8HY1l73XhHG3JT2_dN6IYhQfEtlaa8-OaKYAsv9v9E_yR2b8gRWBk3RY381MdN216clW-DeuHwcgVaDTBpadWDEDC3ab9qduBdJ5MQ9po0o",
            // purposes: [
            //   {
            //     Id: "f2615df6-aac6-4b7b-94eb-f0933a066a6d",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** UAT END ****
            // **** PRODUCTION START ****
            // requestInformation:
            //   "eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImEzOWYzOGZmLWI5OGMtNDhjNS04NDg0LTg3YjE1Yzg0MmY3OCIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTA1LTI3VDA2OjMxOjUxLjc1NyIsIm1vYyI6IkFQSSIsInBvbGljeV91cmkiOm51bGwsInN1YiI6IkVtYWlsIiwiaXNzIjpudWxsLCJ0ZW5hbnRJZCI6IjU3MGRjNGUwLTYxZmQtNDkyNi05MDk0LTI5MGQ3YjViM2NiNiIsImRlc2NyaXB0aW9uIjoiUHJvbXB0RGVlX0Nvb2tpZXMgQnV5ZXIgVUFUIiwiY29uc2VudFR5cGUiOiJDT05ESVRJT05BTFRSSUdHRVIiLCJhbGxvd05vdEdpdmVuQ29uc2VudHMiOmZhbHNlLCJkb3VibGVPcHRJbiI6ZmFsc2UsInB1cnBvc2VzIjpbeyJpZCI6IjM0ODIwZDczLWU5MmItNDk3Yi1hMmFlLTYxNDliMTRmZTNkZCIsInZlcnNpb24iOjIsInBhcmVudElkIjpudWxsLCJ0b3BpY3MiOltdLCJjdXN0b21QcmVmZXJlbmNlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX1dLCJub3RpY2VzIjpbXSwiZHNEYXRhRWxlbWVudHMiOltdLCJhdXRoZW50aWNhdGlvblJlcXVpcmVkIjpmYWxzZSwicmVjb25maXJtQWN0aXZlUHVycG9zZSI6ZmFsc2UsIm92ZXJyaWRlQWN0aXZlUHVycG9zZSI6dHJ1ZSwiZHluYW1pY0NvbGxlY3Rpb25Qb2ludCI6ZmFsc2UsImFkZGl0aW9uYWxJZGVudGlmaWVycyI6W10sIm11bHRpcGxlSWRlbnRpZmllclR5cGVzIjpmYWxzZSwiZW5hYmxlUGFyZW50UHJpbWFyeUlkZW50aWZpZXJzIjpmYWxzZSwicGFyZW50UHJpbWFyeUlkZW50aWZpZXJzVHlwZSI6bnVsbCwiYWRkaXRpb25hbFBhcmVudElkZW50aWZpZXJUeXBlcyI6W10sImVuYWJsZUdlb2xvY2F0aW9uIjpmYWxzZX0.KYSNg6-2j-PiAyIo1pAhSflG6z6dmxmT97bqTQgABvXoAQL-h1lR90eF6J9LMZtSywqm6TPNW566o5EQurkiQ5GtPMwq-x267t8U4DX7O9Z4niB9kazlZ-3muOgJyW-NSfL8cncm2wJtwAIy5R1jRvEpbRyE8N4fclmOJyl_7wlopBZe5HVd7qEYtDdZkxG7bhGt6XjVe6WFWdNsMF5D3zD8KJGuZEkHk7oqBV6s1BNCBDofitRzcnLs50g7jYc_31Dlh1JebNHPnFJpzFAABeSn3KKYbYYctZMHDhPjBdw0E8tZ1gSy_b8Nov8ZUPKatv5XimEWPaXgzC5ngVw5UlWaFXNs5P0_-XnYacBPJMEMrA7dN7WAv5koch9EQyJYrAkcnIb23jSV7CmXakfJoZKRns3LqxPmC6vP1aAQdHoRd5T_-xUxBb0SkPpzaEmKdZ7JKvTip7cw0vH0677IuaZhDGuGIZPgh4IB5xjQ0OgSS4NsdQ3rc3n72iDJ90D1hf7BRxU-XHIkElwisJGrBND6BGFflxmBTizIUOsAKqP-FTeX0_fNgytMoIvHy5T1rSOb9qJJYwJIt1P8WHAxxd_l5o3TWAHf382-3WYVkgid6x5aq8sJ2YQ8RZoNnQdDAl_72rrXgXvudGGMwZGg6Cg88h2Ki5WeOYvA2wfpbcw",
            // purposes: [
            //   {
            //     Id: "34820d73-e92b-497b-a2ae-6149b14fe3dd",
            //     TransactionType: "CONFIRMED",
            //     //   "TransactionType": "WITHDRAWN"
            //   },
            // ],
            // **** PRODUCTION END ****
            requestInformation: `${ONETRUST_PRIVACY.TOKEN}`,
            purposes: [
              {
                Id: `${ONETRUST_PRIVACY.ID}`,
                TransactionType: 'CONFIRMED',
              },
            ],
          });
        }

        const pdpa = {
          privacyPolicy: true,
          termsConditions: true,
          news: isPrivacy,
          personalInformation: false,
        };
        const pdpaDetail = {
          privacyPolicy: {
            version: isProvactyPolicy.version,
            acceptDate: datetoset,
          },
          termsConditions: {
            version: isTermsOfUse.version,
            acceptDate: datetoset,
          },
          news: {
            version: 1,
            acceptDate: datetoset,
          },
          personalInformation: {
            version: 1,
            acceptDate: datetoset,
          },
        };
        const checkBoxsUser = await axios.post(`/pdpa-user`, {
          userId: user?._id,
          version: '1',
          pdpa: {
            privacyPolicy: pdpa.privacyPolicy,
            termsConditions: pdpa.termsConditions,
            news: pdpa.news,
            personalInformation: pdpa.personalInformation,
          },
          pdpaDetail: {
            privacyPolicy: {
              version: pdpaDetail.privacyPolicy.version,
              acceptDate: pdpaDetail.privacyPolicy.acceptDate,
            },
            termsConditions: {
              version: pdpaDetail.termsConditions.version,
              acceptDate: pdpaDetail.termsConditions.acceptDate,
            },
            news: {
              version: pdpaDetail.news.version,
              acceptDate: pdpaDetail.news.acceptDate,
            },
            personalInformation: {
              version: pdpaDetail.personalInformation.version,
              acceptDate: pdpaDetail.personalInformation.acceptDate,
            },
          },
        });
        const checkBoxsLog = await axios.post(`/pdpa-log`, {
          userId: user?._id,
          version: '1',
          pdpa: {
            privacyPolicy: pdpa.privacyPolicy,
            termsConditions: pdpa.termsConditions,
            news: pdpa.news,
            personalInformation: pdpa.personalInformation,
          },
          pdpaDetail: {
            privacyPolicy: {
              version: pdpaDetail.privacyPolicy.version,
              acceptDate: pdpaDetail.privacyPolicy.acceptDate,
            },
            termsConditions: {
              version: pdpaDetail.termsConditions.version,
              acceptDate: pdpaDetail.termsConditions.acceptDate,
            },
            news: {
              version: pdpaDetail.news.version,
              acceptDate: pdpaDetail.news.acceptDate,
            },
            personalInformation: {
              version: pdpaDetail.personalInformation.version,
              acceptDate: pdpaDetail.personalInformation.acceptDate,
            },
          },
        });
      }
    });
  };

  const clone = async () => {
    localStorage.setItem('DataFixTime', '');
    setDateText(false);
  };

  const days = () => {
    const date1 = new Date('09/1/2022');
    const date2 = new Date();
    let difference = date1.getTime() - date2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    setdueDate(TotalDays);
  };

  const checkLog = async () => {
    axios.get(`/pdpa-user/${user?._id}`).then((data) => {
      if (data.data) {
        setIsPrivacy(data?.data?.pdpa?.news);
        if (
          data?.data?.pdpa?.privacyPolicy === true &&
          data?.data?.pdpa?.termsConditions === true
        ) {
          setIsNetwork(false);
          if (data?.data?.pdpa.news === false) {
            setIsNew(true);
          }
        } else {
          setIsNetwork(true);

          if (data?.data?.pdpa?.news === false) {
            setIsNew(true);
            setIsPrivacy(data?.data?.pdpa?.news);
          }
        }
      } else {
        setIsNew(true);
        setIsNetwork(true);
      }
    });
  };
  const onPrivacyNotice = () => {
    navigate('/PrivacyNotice');
  };
  const getTerm = async () => {
    const allOrder = await axios.get(`/term-of-use/role?role=buyer`);
    const term = {
      content: htmlDecode(allOrder.data.termOfUse),
      version: 1,
    };
    setTermsOfUse(term);
  };
  const htmlDecode = (content: any) => {
    let e = document.createElement('div');
    e.innerHTML = content;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  };
  useEffect(() => {
    if (isFetchedUser) {
      if (user?._id) {
        const DataFixTime = localStorage.getItem('DataFixTime');
        const ONETRUST_PROVACTY_POLICY = `${ONETRUST_PRIVACY_POLICY_URL}`;
        fetch(ONETRUST_PROVACTY_POLICY)
          .then((response) => response.json())
          .then((jsonData) => {
            // jsonData is parsed json object received from url
            const provactyPolicy =
              jsonData.notices[Object.keys(jsonData.notices)[0]];
            const provactyPolicyDetail = {
              content: provactyPolicy.content,
              version: provactyPolicy.publicVersion,
            };

            setProvactyPolicy(provactyPolicyDetail);
            setTimeout(() => {
              axios.get(`/pdpa-user/${user?._id}`).then((data) => {
                if (isTermsOfUse && provactyPolicyDetail) {
                  if (data.data) {
                    setIsPrivacy(data?.data?.pdpa?.news);
                    if (
                      isTermsOfUse.version !==
                        data?.data?.pdpaDetail?.termsConditions?.version &&
                      provactyPolicyDetail.version !==
                        data?.data?.pdpaDetail?.privacyPolicy?.version
                    ) {
                      axios.patch(
                        `/pdpa-user/check-version-user-pdpa/${user?._id}`,
                        {
                          pdpaDetail: {
                            privacyPolicy: {
                              version: provactyPolicyDetail.version,
                            },
                            termsConditions: {
                              version: isTermsOfUse.version,
                            },
                          },
                        }
                      );
                      checkLog();
                    } else if (
                      provactyPolicyDetail.version !==
                      data?.data?.pdpaDetail?.privacyPolicy?.version
                    ) {
                      axios.patch(
                        `/pdpa-user/check-version-user-pdpa/${user?._id}`,
                        {
                          pdpaDetail: {
                            privacyPolicy: {
                              version: provactyPolicyDetail.version,
                            },
                            termsConditions: {
                              version:
                                data?.data?.pdpaDetail?.termsConditions
                                  ?.version,
                            },
                          },
                        }
                      );
                      checkLog();
                    } else if (
                      isTermsOfUse.version !==
                      data?.data?.pdpaDetail?.termsConditions?.version
                    ) {
                      axios.patch(
                        `/pdpa-user/check-version-user-pdpa/${user?._id}`,
                        {
                          pdpaDetail: {
                            privacyPolicy: {
                              version:
                                data?.data?.pdpaDetail?.privacyPolicy?.version,
                            },
                            termsConditions: {
                              version: isTermsOfUse.version,
                            },
                          },
                        }
                      );
                      checkLog();
                    } else {
                      if (
                        data?.data?.pdpa?.privacyPolicy === true &&
                        data?.data?.pdpa?.termsConditions === true
                      ) {
                        setIsNetwork(false);
                        if (data?.data?.pdpa.news === false) {
                          setIsNew(true);
                        }
                      } else {
                        setIsNetwork(true);

                        if (data?.data?.pdpa?.news === false) {
                          setIsNew(true);
                          setIsPrivacy(data?.data?.pdpa?.news);
                        }
                      }
                    }
                  } else {
                    setIsNew(true);
                    setIsNetwork(true);
                  }
                }
              });
            }, 700);
          })
          .catch((error) => {
            // handle your errors here
            console.error(error);
          });

        if (DataFixTime === 'true') {
          setDateText(true);
        }
        if (!isManualLoading) {
          setIsLoaded(true);
        }
        setIsPermitted(true);
      } else {
        if (
          window.location.pathname !== '/' &&
          window.location.pathname.indexOf('/product-detail/') === -1 &&
          window.location.pathname.indexOf('/search') === -1 &&
          window.location.pathname.indexOf('/product-categories') === -1 &&
          window.location.pathname.indexOf('/shops') === -1 &&
          window.location.pathname.indexOf('/register') === -1 &&
          window.location.pathname.indexOf('/login') === -1 &&
          window.location.pathname.indexOf('/promotions') === -1 &&
          window.location.pathname.indexOf('/partner') === -1
        ) {
          navigate(`/`);
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('code')) {
            navigate(`/login`);
          } else {
            setDateText(true);
            setIsLoaded(true);
            setIsPermitted(true);
          }
        }
      }
    }
  }, [isFetchedUser, user]);

  useEffect(() => {
    if (isManualLoading) {
      setIsLoaded(layoutLoaded);
    }
  }, [isManualLoading, layoutLoaded]);

  useEffect(() => {
    if (user?._id) {
      getCarts(user?._id);
      let script2 = document.createElement('script');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      // COOKIE BANNER SCRIPT **START**
      // **** UAT START ****
      // script2.setAttribute(
      //   "src",
      //   "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      // );
      // script2.setAttribute(
      //   "data-domain-script",
      //   "17aeff90-313e-4131-95af-75a7a9ec8f99"
      // );
      // **** UAT END ****
      // **** PRODUCTION START ****
      // script2.setAttribute(
      //   "src",
      //   "https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
      // );
      // script2.setAttribute(
      //   "data-domain-script",
      //   "9bb36785-da50-43c1-b20a-dbbf1e24c344"
      // );
      // COOKIE BANNER SCRIPT **END**
      // document.head.appendChild(script2);
    }
  }, [user]);
  useEffect(() => {}, [isNew]);
  useEffect(() => {
    if (isScrollingInModal) {
      setIsChecker(true);
    } else {
      setIsChecker(false);
    }
  }, [isScrollingInModal]);
  useEffect(() => {
    getTerm();
    getLoaderGoogle();
    getSettings();
    getLocation();
    days();

    // let script = document.createElement("script");
    // script.src =
    //   "https://maps.googleapis.com/maps/api/js?key=AIzaSyD4xHcwbP4G7ZqqPCFN_i1zKKyM_eIfY0w";
    // script.async = true;
    // document.body.appendChild(script);
  }, []);

  return (
    <>
      <div>
        <div
          className={[styles.containerWrapper, styles.minheight].join(' ')}
          style={{ paddingBottom: paddingBottom }}
        >
          <TopNavbar logoPath='/' showTechnicianBar={showTechnicianBar} />

          <div
            className={styles.container}
            style={{ maxWidth: containerMaxWidth }}
          >
            {!isLoaded ? (
              <div className={styles.loadingWrapper}>
                <Loading />
              </div>
            ) : !isPermitted ? (
              <div className={styles.notPermittedWrapper}>
                <NotPermit />
              </div>
            ) : (
              <>
                <Breadcrumbs
                  items={breadcrumbItems}
                  marginBottom={breadcrumbMarginBottom}
                />
                <div className={styles.bodyWrapper}>{children}</div>
              </>
            )}
          </div>

          <Modal
            visible={isNetwork}
            centered
            // footer={false}
            width={750}
            closeIcon
            className={styles.modalPolicy}
            // bodyStyle={{ height: 500 }}
            footer={[
              <div className={styles.alignLeft}>
                {isNew ? (
                  <div>
                    <Checkbox
                      // disabled={isScrolling}
                      checked={isPrivacy}
                      onChange={(e) => setIsPrivacy(e.target.checked)}
                      style={{ padding: 6 }}
                    >
                      <b>
                        ข้าพเจ้ายินยอมรับข่าวสารและสิทธิประโยชน์ ผ่านทางอีเมล
                        เอสเอ็มเอส แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์
                        และไดเร็กเมลจากบริษัท เอสซีจี ดิสทริบิวชั่น จำกัด
                        ผู้ให้บริการ PromptDee
                      </b>
                    </Checkbox>
                  </div>
                ) : (
                  <div></div>
                )}
                <div>
                  <Checkbox
                    checked={isScrollingInModal}
                    onChange={(e) => setIsScrollingInModal(e.target.checked)}
                    style={{ padding: 6 }}
                  >
                    <b>
                      ข้าพเจ้าเข้าใจและตกลงตาม ข้อกำหนดและเงื่อนไข
                      รวมทั้งเข้าใจถึงเรื่องการเก็บ ใช้
                      และเปิดเผยข้อมูลส่วนบุคคลตาม นโยบายความเป็นส่วนตัว
                    </b>
                  </Checkbox>
                </div>
                <div>
                  <Button onClick={handleCancel} disabled={!isChecker}>
                    ตกลงและเริ่มใช้งาน
                  </Button>
                </div>
              </div>,
            ]}
          >
            <div style={{ overflow: 'auto', height: '50vh' }}>
              <Card bordered={false} className={styles.cardBody}>
                {isTermsOfUse ? (
                  <div
                    id='otnotice-f4d306bf-5d80-428d-be47-d8e406eeec9a'
                    className='otnotice'
                    dangerouslySetInnerHTML={{
                      __html: isTermsOfUse.content,
                    }}
                  ></div>
                ) : (
                  <></>
                )}
              </Card>
              <Card bordered={false} className={styles.cardBody}>
                {isProvactyPolicy ? (
                  <div
                    id='otnotice-f4d306bf-5d80-428d-be47-d8e406eeec9a'
                    className='otnotice'
                    dangerouslySetInnerHTML={{
                      __html: isProvactyPolicy.content,
                    }}
                  ></div>
                ) : (
                  <></>
                )}
              </Card>
            </div>
          </Modal>
          {/* {dueDate > 0 ? (
            <>
              {isDateText ? (
                <div
                  style={{
                    position: "fixed",
                    zIndex: 99,
                    bottom: 10,
                    right: 10,
                  }}
                >
                  <Card style={{ width: 300, backgroundColor: "#bebebe" }}>
                    <Card
                      style={{
                        position: "fixed",
                        zIndex: 99,
                        bottom: 267,
                        right: 18,
                        height: "21px",
                        width: "21px",
                      }}
                    ></Card>
                    <div
                      style={{
                        position: "fixed",
                        zIndex: 99,
                        bottom: 265,
                        right: 20,
                      }}
                    >
                      <a onClick={clone}>
                        <CloseOutlined
                          style={{ color: "black", fontSize: "16px" }}
                        />
                      </a>
                    </div>

                    <div>
                      &nbsp;&nbsp;&nbsp;&nbsp;ท่านสามารถขอยกเลิกความยินยอมในการประมวลผลข้อมูลส่วนบุลคล
                      ที่เว็บไซต์เก็บรวบรวมไว้
                      ก่อนวันที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
                      ใช้บังคับ โดยติดต่อผู้ควบคุมข้อมูลส่วนบุคคลที่ระบุไว้ใน
                      &nbsp;
                      <a onClick={onPrivacyNotice}>
                        นโยบายความเป็นส่วนตัว
                      </a>{" "}
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;สำหรับข้อมูลส่วนบุคคลประเภทบุคคล
                      ประเภทอื่นๆ ที่เอสซีจี(บริษัทปูนซีเมนต์ไทย จำกัด (มหาชน)
                      และบริษัทในกลุ่มเอสซีจีตามงบการเงินรวม) ได้เก็บรวบรวมไว้
                      โปรดติดต่อ data.privacy@scg.com
                    </div>
                  </Card>
                </div>
              ) : (
                <div></div>
              )}
            </>
          ) : (
            <div></div>
          )} */}
        </div>
        <ButtomFooter logoPath='/' />
      </div>
    </>
  );
};
export default Layout;
